/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component } from 'react'

const workerStatus = global.rootRequire('classes/globalStatus')
const { rxaget, autoConvertTime } = global.rootRequire('classes/ulti')


class OnOffUser_ extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
    }
    this.currentUserId = rxaget(props, 'userId', '')
    this.currentStatus = false
    this.lastseen = 0

    if (this.currentUserId) {
      if (this.currentUserId && workerStatus.status[this.currentUserId]) {
        this.currentStatus = workerStatus.status[this.currentUserId]['status'] || false
        this.lastseen = workerStatus.status[this.currentUserId]['last_seen'] || 0
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    try {
      let flagReturn = false
      let userId = rxaget(nextProps, 'userId', '')
    
      if (rxaget(nextProps, 'rxUserStatus', false) !== rxaget(this.props, 'rxUserStatus', false) || (userId !== this.currentUserId)) {
        this.currentUserId = userId

        if (userId && workerStatus.status[userId] && (workerStatus.status[userId]['status'] !== this.currentStatus || workerStatus.status[userId]['last_seen'] !== this.lastseen)) {
          this.currentStatus = workerStatus.status[userId]['status'] || false
          this.lastseen = workerStatus.status[userId]['last_seen'] || 0
        } else if (userId && workerStatus.status[userId]['status'] === this.currentStatus) {
          // No handle
        } else {
          this.currentStatus = false
          this.lastseen = 0
        }

        flagReturn = true
      }

      return flagReturn
    } catch(e) {
      this.currentStatus = false
      this.lastseen = 0
      return true
    }
  }

  render() {
    return (<React.Fragment>
      {this.currentStatus && <>{(this.props.className) ? <span className='status-online'>{translate('Online')}</span> : translate('Online')}</>}
      {(!this.currentStatus && this.lastseen === 0) && <>{translate('Offline')}</>}
      {(!this.currentStatus && this.lastseen > 0) && <>{translate('Last seen ') + autoConvertTime(this.lastseen)}</>}
    </React.Fragment>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  rxUserStatus: state.rxUserStatus
})

const mapDispatchToProps = {}

const OnOffUser = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnOffUser_)

export default OnOffUser